import HomeContainer from "../containers/home_container";

export default function Home() {
    // const token = useToken();
    // if ( token===null ){
    //     return <Redirect to="/signin" />
    // }
    return <HomeContainer />
}
